import axios from "axios";
import { API } from "config";

const getAuthConfig = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    if (userInfo?.access_token) {
      return {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
          "Content-Type": "application/json",
        },
      };
    }
  } catch (error) {
    return {};
  }

  return {};
};

const getErrorMessage = (error) => {
  if (!error.response) {
    return error.message || "Request failed";
  }

  const data = error.response.data;

  if (data && Array.isArray(data.errors) && data.errors.length > 0) {
    return data.errors[0].message || data.errors[0];
  }

  if (data && data.message) {
    return data.message;
  }

  return error.message || "Ncell request failed";
};

export const validateNcellCode = async (code) => {
  try {
    const { data } = await axios.get(`${API}/api/orders/ncell/transaction`, {
      ...getAuthConfig(),
      params: { code },
    });

    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const confirmNcellRedemption = async ({ callbackUrl, remarks }) => {
  try {
    const { data } = await axios.post(
      `${API}/api/orders/ncell/redeem`,
      { callback_url: callbackUrl, remarks },
      getAuthConfig()
    );

    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
